<template>
  <div class="app-wrapper hideSidebar">
    <div class="content-container">
        <sidebar class="sidebar-container" />
        <div class="main-container hasTagsView">
          <div :class="{'fixed-header':fixedHeader}">
            <template v-if="currentDomain.indexOf('admin.geekyum') > -1">
              <admin-navbar />
            </template>
            <template v-else>
              <navbar />
            </template>
            <tags-view />
          </div>
          <app-main />
        </div>
    </div>
    <feedback />
  </div>
</template>

<script>
import { AppMain, Navbar, Sidebar, TagsView,AdminNavbar } from './components'
import { mapState } from 'vuex'
import Feedback from './components/Feedback';
export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    Sidebar,
    TagsView,
    Feedback,
    AdminNavbar
  },
  computed: {
    ...mapState({
      showSettings: state => state.settings.showSettings,
      fixedHeader: state => state.settings.fixedHeader
    })
  },
  data(){
    return {
      currentDomain:window.location.hostname
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "./mixin.scss";
  @import "../../styles/variables.scss";

  .content-container {
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

  }

  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    width: calc(100% - 64px);
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    transition: width 0.28s;
  }
</style>
